export default {
  data: {
    modal: null,
    holder: null,
    isOpen: false
  },

  init (data, holder) {
    this.data.holder = holder
    this.data.modal = document.createElement('div')
    this.data.modal.classList.add('external-content-container', 'visible')
    if (data.isFullWidth) this.data.modal.classList.add('full-width')

    this.data.modal.insertAdjacentHTML('beforeend', `
      <header>
        <h3>${data.title}</h3>
        <button class="close"></button>
      </header>
      <div class="content">
        <span class="spinner"></span>
        <iframe src="${data.src}"></iframe>
      </div>
    `)

    holder.appendChild(this.data.modal)
    holder.querySelector('button.close').addEventListener('click', () => this.closeModal())
    holder.querySelector('iframe').onload = () => { this.data.holder.querySelector('.spinner').style.display = 'none' }
  },

  openModal (data, holder) {
    /**
     * isOpen : to prevent the user from altering the code in the browser and opening multiple iframes
     */
    if (this.isOpen) return
    this.init(data, holder)
    this.isOpen = true
  },

  closeModal () {
    this.data.modal.classList.remove('visible') // to fade out
    setTimeout(() => {
      this.data.holder.style.cssText = ''

      this.data.holder.removeChild(this.data.modal)
      this.isOpen = false
    }, 510)
  }

}



// WEBPACK FOOTER //
// ./src/utils/modal.js